import React from 'react';
import styles from '../../Steppers/AlertStepper.module.scss';
import { ALERT_DETAILS } from '../../../../containers/Alerts/constants.alerts';
import DeviceModelSupportInfo from '../../Common/DeviceModelSupportInfo';

const TamperAlert = () => (
    <div className={styles['.step-content']}>
        <div className={styles['vertical-divider']}>
            <div className={styles['step-rightside']}>
                <div>
                    <DeviceModelSupportInfo
                        label={ALERT_DETAILS.LABEL.DEVICE_SPECIFIC_ALERT}
                        tooltipText="Supported devices are Flex Battery, Flex 2 and Flex 2+."
                    />
                </div>
            </div>
        </div>
    </div>
);

export default TamperAlert;
